import { useEmmaJS } from './useEmmaJS';
import { useEffect } from 'react';
import { useReactNativeMessage } from './useReactNativeMessageManager';
import { REACT_NATIVE_MESSAGE_TYPES } from './react-native-message-manager';
import { isInsideChatbot } from '../helpers/common';

export const useOverrideCloseEvent = ({
  enable = true,
  callback,
}: {
  enable?: boolean;
  callback?: () => void;
}) => {
  const EmmaJs = useEmmaJS();

  useEffect(() => {
    if (!EmmaJs?.instance) return;
    if (isInsideChatbot()) return;
    if (enable) {
      EmmaJs?.instance?.overrideCloseEvent?.();
    } else {
      EmmaJs?.instance?.resetCloseEvent?.();
    }
  }, [EmmaJs, enable]);

  useReactNativeMessage(REACT_NATIVE_MESSAGE_TYPES.CLOSE_EVENT, () =>
    callback?.(),
  );
};

export default useOverrideCloseEvent;
